<template>
    <div class="call-task-cate-manage-upload-task">
        <div style="display: flex;">
            <div style="margin-left: auto;"><i class="el-icon-refresh" style="cursor: pointer;color: #409EFF;"
                    @click="loadTable"></i></div>
        </div>
        <el-table :data="tableData" style="width: 100%;margin-top: 0.2rem" border size="mini" height="65vh"
            :header-cell-style="{
                        background: '#ecf4ff',
                        color: '#333',
                        fontWeight: '900',
                        fontSize: '0.28rem'
                    }" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
            <el-table-column prop="" label="序号" width="50" align="center">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="file_name" label="文件名" width="" align="center">
            </el-table-column>
            <el-table-column prop="" label="创建人" width="" align="center">
                <template slot-scope="scope">
                    <div>
                        <div>{{ scope.row.admin_user_name }}</div>
                        <div>{{ scope.row.created_at }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="任务状态" width="" align="center">
            </el-table-column>
            <el-table-column prop="total_num" label="文件内总数" width="" align="center">
            </el-table-column>
            <el-table-column prop="success_num" label="任务创建成功" width="" align="center">
            </el-table-column>
            <el-table-column prop="repeat_num" label="任务重复数量" width="" align="center">
            </el-table-column>
            <el-table-column prop="exists_num" label="公司名称不存在" width="" align="center">
            </el-table-column>
            <el-table-column prop="invalid_num" label="无效条目数" width="" align="center">
            </el-table-column>
        </el-table>
        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>
    </div>
</template>

<script>
import PaginationCom from '../../../commonReform/PaginationCom';
export default {
    name: 'CallTaskCateManageUploadTask',
    components: { PaginationCom },
    props: {
        cateId: {
            type: Number
        }
    },
    data() {
        return {
            tableData: [],
            loading: false,
            pageSize: 30,
            total: 0,
            npage: 1,
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            hyperfHostWithOutV1:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/"
                    : "https://qyh-next-server.zhang66.cn/",
            cate_id: null
        }
    },
    methods: {
        loadTable() {
            this.loading = true
            this.$axios.get(`${this.hyperfHost}qyh/call-task-manage/show?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    perPage: this.pageSize,
                    cate_id: this.cateId
                    // searchArr: this.searchArr,
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loading = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
    },
    watch: {
        cateId: {
            immediate: true,
            handler(n) {
                if (n) this.loadTable()
            }
        }
    },
    mounted() {
        // this.loadTable()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/CallTaskCateManageUploadTask.vue